import { createGlobalStyle } from "styled-components"

const phoneWidth = "760px"
const tabletWidth = "1200px"

const Globalstyle = createGlobalStyle`
  html {
    font-size: 16px;
  }
  
  :root {
    // Colors
    --transparent: rgba(0,0,0,0);
    --gray-50: #f9fafb;
    --gray-100: #f3f4f6;
    --gray-200: #e5e7eb;
    --gray-300: #d1d5db;
    --gray-400: #9ca3af;
    --gray-500: #6b7280;
    --gray-600: #4b5563;
    --gray-700: #374151;
    --gray-800: #1f2937;
    --gray-900: #111827;

    // Main site
    --yellow: #FDD65B;
    --gray: #212121;
    --light-gray: #2B2B2B;

    // Sylhet Relief
    --dark-green: #3F4B16;
    --green: #A4C239;
    --tan: #F3F2E7;
    --gray: #808080;
    --dark-red: #AE2929;

    // Sizes and spacing
    --body-height: 100vh;
    --side-padding: 5rem;
    --phone-width: ${phoneWidth};
    --tablet-width: ${tabletWidth};
  }
  
  body {
    margin: 0;
    padding: 0;
    font-family: 'Nunito', sans-serif;
    background-color: black;
    color: white;
  }

  p {
    color: var(--gray-300);
  }

  button {
    font-family: 'Nunito', sans-serif;
  }

  @media (max-width: ${tabletWidth}) {
    :root {
      font-size: 12px;
    }
  }

  @media (max-width: ${phoneWidth}) {
    :root {
      font-size: 12px;
    }
  } 
`

export default Globalstyle
export { phoneWidth, tabletWidth }